import React from 'react';
import { StyleSheet } from 'react-native';

import { Button } from '@/components/ButtonComponent';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { UserAvatar } from '@/feature/account-details/components/UserAvatar';
import { avatarUrlSelector, useAuthUserConfig } from '@/hooks/use-auth-user-config';

type Props = {
    onDismiss: () => void;
    onEdit: () => void;
};

export const EditUsernameAvatarBanner = ({ onDismiss, onEdit }: Props) => {
    const { data: avatarUrl } = useAuthUserConfig({ select: avatarUrlSelector });

    return (
        <Box alignItems="center" paddingBottom="s40">
            <UserAvatar avatarUrl={avatarUrl} avatarContainerStyles={styles.avatarContainer} />
            <SizedBox value={8} />
            <Text variant="titleMedium" color={ds.colorToken.text.primary} textAlign="center">
                Edit Username & Avatar
            </Text>
            <SizedBox value={4} />
            <Text variant="bodySmall" color={ds.colorToken.text.secondary} textAlign="center">
                You can now edit your username and avatar by going to your Account Details.
            </Text>
            <SizedBox value={16} />
            <Box flexDirection="row" alignItems="center">
                <Button label="Edit" size="s" hierarchy="primary" onPress={onEdit} style={styles.button} />
                <SizedBox value={12} />
                <Button label="Dismiss" size="s" hierarchy="secondary" onPress={onDismiss} style={styles.button} />
            </Box>
        </Box>
    );
};

const styles = StyleSheet.create({
    button: {
        width: 82,
    },
    avatarContainer: {
        backgroundColor: ds.colorValue.background.neutral.subtler,
        borderColor: ds.colorValue.border.subtle,
    },
});
